var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalLoanLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.75,
    height: 33,
    viewBox: "0 0 24.75 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location",
    d: "M116.375,426.469a3.094,3.094,0,1,1,3.094-3.094,3.094,3.094,0,0,1-3.094,3.094Zm0-8.25a5.156,5.156,0,1,0,5.156,5.156,5.156,5.156,0,0,0-5.156-5.156Zm0,22.688c-1.715.009-10.312-13.22-10.312-17.531a10.313,10.313,0,0,1,20.625,0c0,4.254-8.624,17.541-10.312,17.531Zm0-29.906A12.376,12.376,0,0,0,104,423.375c0,5.175,10.318,20.636,12.375,20.625,2.025.011,12.375-15.52,12.375-20.625A12.376,12.376,0,0,0,116.375,411Z",
    transform: "translate(-104 -411)",
    fill: "#a6192e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalLoanLocationPin);
export default __webpack_public_path__ + "static/media/digital-loan-location-pin.a9ce0992641de12f75442c55c2855fe0.svg";
export { ForwardRef as ReactComponent };